var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Documents',{attrs:{"expanded":"","uploadUrl":_vm.uploadUrl,"data-documents":_vm.user.documents,"title":"Upload User Document","extraFields":{ type: 'user' },"uploadDocs":true,"deleteDocs":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }